import { map } from "rxjs/operators";
import {
  Component,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";
import { Observable } from "rxjs";

import {
  AngularFireStorage,
  AngularFireStorageReference,
  AngularFireUploadTask,
} from "@angular/fire/storage";

/* image upload component, saves to firebase and returns url to post to mongogb
   tutorial source: https://medium.com/codingthesmartway-com-blog/firebase-cloud-storage-with-angular-394566fd529 
*/

@Component({
  selector: "image-upload-form",
  templateUrl: "./image-upload-form.component.html",
  styleUrls: [
    "./image-upload-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ImageUploadForm implements OnInit {
  @Input() targetObject: any;
  @Input() targetType: string;
  @Output() emitImage = new EventEmitter<string>();

  // firebase variables
  public ref: AngularFireStorageReference;
  public task: AngularFireUploadTask;
  public uploadState: Observable<string>;
  public uploadProgress: Observable<number>;
  public downloadURL: string;

  constructor(private afStorage: AngularFireStorage) {}

  ngOnInit() {}

  public async save() {
    if (this.downloadURL) {
      this.emitImage.emit(this.downloadURL);
    }
  }

  // source: https://stackoverflow.com/questions/50541836/property-downloadurl-does-not-exist-on-type-angularfireuploadtask/50663965
  public async upload(event) {
    var directory, fileName;

    if (this.targetType === "User") {
      directory = "profiles";
      fileName = this.targetObject.username;
    }

    if (this.targetType === "Community") {
      directory = "communities";

      if (this.targetObject.id) {
        fileName = this.targetObject.name;
      }
    }

    if (this.targetType === "Discussion") {
      directory = "discussions";

      if (this.targetObject.slug) {
        fileName = this.targetObject.slug;
      }
    }

    this.ref = this.afStorage.ref(`images/${directory}/${fileName}`);
    this.task = this.ref.put(event.target.files[0]);
    this.uploadState = this.task.snapshotChanges().pipe(map((s) => s.state));

    await this.task;

    this.uploadProgress = this.task.percentageChanges();
    this.downloadURL = await this.ref.getDownloadURL().toPromise();
  }
}
